export function split(value) {
    const [min, max] = value.split(';');
    return { min: parseInt(min), max: parseInt(max) ?? undefined };
}

export function join({ min = '', max = '' }) {
    return `${min ?? ''};${max ?? ''}`;
}